import styled from 'styled-components';
import colors from '../../../../styles/colors';

export const MainListContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 5px;
    width: 95%;
    background-color: ${colors.bgColorBlack2};
    border-radius: 15px;
    overflow: hidden;
    margin: 0 auto;
    color: white;
    padding: 15px;
    font-family: CameronSansMedium;
`;

export const SpaceSingleCard = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: calc(33.3% - 5px);
`;

export const BoxSingleCard = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 180px;
    background-color: ${colors.bgColorBordeaux};
    border-radius: 5px;
    border: 1px solid white;
    padding: 5px;

    &:hover {
        transform: scale(1.05);
        transition: transform 0.3s ease-in-out;
    }

    & img.poster-ppv {
        width: 100%;
        height: 80%;
        object-fit: cover;
        object-position: top;
    }

    & .box-info-ppv {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 20%;
        font-size: 10px;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1;
        text-align: center;
        margin: 0;
        padding: 0;
    }

    & .box-info-ppv.left {
        /* justify-content: flex-end; */
        /* text-align: right; */
    }

    & .box-info-ppv.right {
        /* justify-content: flex-start; */
        /* text-align: left; */
    }
`;
